module.exports = __webpack_public_path__ + "img/edit.bd5931cb.png";